import React from "react";
import { ButtonLarge } from "../../components/ButtonLarge";
import { Footer } from "../../components/Footer";
import { Nav } from "../../components/Nav";
import { Shortcuts } from "../../components/Shortcuts";
import "./style.css";

export const LandingPage = () => {
  return (
    <div className="main landing-page" id="main">
      <Nav className="nav-instance" nav="default" />
      <div className="overlap">
        <div className="content">
          <div className="hero">
            <div className="group">
              <div className="overlap-group">
                <div className="rectangle-2" />
              </div>
            </div>
            <p className="p">Welcome to recruit22! <br />a forward-thinking staffing firm.</p>
          </div>
          <div className="shortcuts-div">
            <div className="div-wrapper">
              <div className="text-wrapper-4">Shortcuts available</div>
            </div>
            <Shortcuts className="design-component-instance-node" shortcuts="default" />
          </div>
          <div className="element-2">
            <div className="div-2">
              <p className="text-wrapper-white">
                We are passionate about shaping the future of recruitment. We embrace innovation, adapt to change,
                and challenge the status quo.
              </p>
            </div>
            <div className="image">
              <div className="rectangle-wrapper">
                <div className="rectangle-3" />
              </div>
            </div>
            <div className="sub">
              <div className="CTA">
                <ButtonLarge className="button-large-instance" text="Hire Talent" linkTo="/talent" target="_self"/>
              </div>
              <div className="text">
                <p className="text-wrapper-6 .text-black">
                  Partner with us to access top talent, embrace diversity, and overcome the challenges of modern
                  recruitment. Together, let’s build exceptional teams that drive success in the digital era.
                </p>
              </div>
            </div>
          </div>
          <div className="element-3">
            <div className="div-2">
              <p className="text-wrapper-7">
                Discover exciting career opportunities that match your skills and aspirations. At recruit22, we pride
                ourselves on connecting talented individuals with top-notch companies.
              </p>
            </div>
            <div className="group-wrapper">
              <div className="group-2">
                <div className="rectangle-4" />
              </div>
            </div>
            <div className="sub">
              <div className="CTA-2">
                <ButtonLarge className="button-large-black" text="Explore Opportunities" linkTo="/jobs#jobPosts" />
              </div>
              <div className="text-2">
                <p className="text-wrapper-black">
                  Our job listings are carefully curated, featuring a wide range of positions across various industries.
                  Whether you’re an experienced professional seeking new challenges or a fresh graduate looking to
                  kick-start your career, our platform offers a diverse selection of roles that could be your next
                  career move.
                </p>
              </div>
            </div>
          </div>
          <div className="element-4">
            <div className="div-2">
              <p className="text-wrapper-7">
                We are a dedicated team of industry experts passionate about connecting exceptional professionals with
                outstanding career opportunities.
              </p>
            </div>
            <div className="image">
              <div className="group-3" />
            </div>
            <div className="sub">
              <div className="CTA-2">
                  <ButtonLarge className="button-large-black" text="Meet the team" linkTo="/about-us" />
              </div>
              <div className="text-2">
                <p className="text-wrapper-black">
                  What sets us apart is our unwavering commitment to excellence and our genuine passion for making
                  meaningful connections. We take the time to truly understand your organization’s culture, objectives,
                  and vision, enabling us to deliver candidates who not only possess the required skills but also thrive
                  in your environment.
                </p>
              </div>
            </div>
          </div>
          <Footer
            footer="default"
          />
        </div>
        
      </div>
      
    </div>
  );
};
